export const QUEUE_EFFECT = '@opengov/compose-app/QUEUE_EFFECT';
